import { DownloadAppCtaExperience } from '@/services/settingsService/settingsTypes';

export const downloadAppCtaAdGroup = 'download-app-cta';
export const downloadAppCtaOverrideParam = 'downloadAppCta';
export const defaultDownloadAppCtaUrl = 'https://x.bndspn.com/v1/or-3n123d';

export const isDownloadAppCtaExperience = (
  value: unknown
): value is Exclude<DownloadAppCtaExperience, 'disabled'> =>
  value === 'download_app_cta';

/* Flows that keep the standard home layout: a gift-code redemption link, or a visitor redirected from the mobile app. */
export function isDownloadAppCtaExcluded({
  searches,
  redirectedFromMobile,
}: {
  searches: string[];
  redirectedFromMobile: boolean;
}): boolean {
  if (redirectedFromMobile) return true;

  return searches.some((search) =>
    new URLSearchParams(search).has('redeemCode')
  );
}

/* QA switch: `?downloadAppCta=download_app_cta` activates the experience, `disabled` forces the control. */
export function resolveDownloadAppCtaUrlOverride(
  search: string
): DownloadAppCtaExperience | undefined {
  const value = new URLSearchParams(search).get(downloadAppCtaOverrideParam);
  if (value === 'disabled') return 'disabled';
  return isDownloadAppCtaExperience(value) ? value : undefined;
}

/* Read at module load: `generateViralityParam` rewrites the URL and drops the query string shortly after. */
export const downloadAppCtaUrlOverrideAtLoad =
  typeof window === 'undefined'
    ? undefined
    : resolveDownloadAppCtaUrlOverride(window.location.search);

export function getDownloadAppCtaUrlOverride():
  | DownloadAppCtaExperience
  | undefined {
  if (typeof window === 'undefined') return undefined;

  return (
    downloadAppCtaUrlOverrideAtLoad ??
    resolveDownloadAppCtaUrlOverride(window.location.search)
  );
}

/* Only Xina tracking links are accepted: a remote value could otherwise redirect anywhere. */
export function getSafeDownloadUrl(downloadUrl: string | undefined) {
  let trackerUrl: URL;
  try {
    const url = new URL(downloadUrl ?? defaultDownloadAppCtaUrl);
    const isXinaTracker =
      url.protocol === 'https:' && url.hostname === 'x.bndspn.com';
    trackerUrl = isXinaTracker ? url : new URL(defaultDownloadAppCtaUrl);
  } catch {
    trackerUrl = new URL(defaultDownloadAppCtaUrl);
  }

  if (!trackerUrl.searchParams.has('params')) {
    trackerUrl.searchParams.set(
      'params',
      JSON.stringify({ 'ad-group': downloadAppCtaAdGroup, platform: 'web' })
    );
  }
  return trackerUrl.toString();
}
